<template>

    <div class="container-fluid">
        <div class="row justify-content-center" v-if="$can('orders read')">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{ $t('orders.details.title')}}</div>
                    <div class="card-body">
                        <form-order
                            :formdisabled="true"
                            :mode="'display'"
                            :orderid="orderid"
                            :context="context"
                        ></form-order>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('orders read')">{{ $t('access-denied') }}</h1>
    </div>


</template>

<script>
import ObjectLister from "./object-lister";
import moment from 'moment'

var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
export default {
    name: "order-display",
    components: {
        ObjectLister,
    },
    props:['user', 'mode', 'formdisabled', 'orderid', 'context'],
    data: function () {
        return {
        }
    },
    mounted () {
        this.init();
    },
    methods: {
        init: function(){
            console.log(("MODUS: " + this.mode));
            console.log(("Kontext: " + this.context));
        },


        goBack(){
            if(window.history.length > 2){
                window.history.back();
            }else{
                //window.location.href = '/orders';
                this.$router.push({ name: 'orders-grid'});
            }
        },

        goBackSimple(){
            if(window.history.length > 2){
                window.history.back();
            }else{
                //window.location.href = '/home';
                this.$router.push({ name: 'dashboard'});
            }
        },

        editAction: function () {
            console.log("edit action", this.orderid);
            this.$router.push({ name: 'order-edit', params: {
                    orderid: this.orderid,
                    mode: 'edit',
                    context: this.context
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
